import script from "./ProjectTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectTitle.vue?vue&type=script&setup=true&lang=js"

import "./ProjectTitle.vue?vue&type=style&index=0&id=0fc27f35&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc27f35"]])

export default __exports__